const lang = {
  login: {
    usernamePlaceholder: '请选择用户名',
    passwordPlaceholder: '请输入登录密码',
    rememberPassword: '记住密码',
    login: '登录',
    incorrectPasswordTip: '密码不正确提示，请重新输入！'
  },
  caseManagement: '样本管理',
  caseUpload: '病例上传',
  scanSettings: '扫描设置',
  scanSettingsStart: '开始',
  scanSettingsSuspend: '暂停',
  scanSettingsStop: '停止',
  scanSettingsReset: '复位',
  language: '语言',
  welcome: '欢迎您',
  exit: '退出',
  exitContent1: '退出后将跳转到登录页',
  exitContent2: '是否确定退出',
  // 查询条件
  newCase: '新建病例',
  pathologyNumber: '病例号',
  caseStatus: '病例状态',
  entryTime: '录入时间',
  startingTime: '开始时间',
  endTime: '结束时间',
  entryTimeTip: '录入开始时间不能大于结束时间',
  inquire: '查询',
  refresh: '刷新',
  tableName: '病例列表',
  /* 病例列表 */
  caseList: {
    serialNumber: '序号',
    name: '姓名',
    gender: '性别',
    menAndWomen: {
      male: '男',
      female: '女'
    },
    age: '年龄',
    uploadStatus: '样本状态',
    fast: '快速',
    // 是否快速
    isFast: {
      yes: '是',
      no: '否'
    },
    caseType: '病例类型',
    sentToHospital: '送检医院',
    number: '病例号',
    sample: '样本',
    createDt: '创建时间',
    operating: '操作',
    // 删除按钮提示
    deletePrompt: {
      title: '删除病例',
      content: '是否确认删除此病例，删除后将无法恢复'
    },
    // 删除结果提示
    deleteResultPrompt: {
      title: '提示',
      success: '删除成功',
      failed: '删除失败'
    },
    // 消息提醒
    messageNotification: '消息提醒',
    // 编辑诊断结果提示
    editDiagnosisResultPrompt: '病例未扫描,请分析完成后再编辑！',
    // 筛选数据提示
    filterDataTips: '病例未扫描,请分析完成后再筛查！',
    // 诊断子按钮
    dataFilteringButton: '数据筛选',
    diagnosticResultButton: '诊断结果',
    viewReportButton: '查看报告',
    editDiagnosisResults: '编辑诊断结果'
  },
  slideTable: {
    serialNumber: '序号',
    sample: '样本',
    slide: '玻片',
    sampleType: '样本类型',
    analysisType: '分析类型',
    analysisResult: '分析结果',
    feminine: '阴性',
    positive: '阳性',
    numberOfCells: '细胞数量',
    status: '状态',
    operation: '操作',
    noSlides: '暂无玻片',
    printBarcode: '打印条码',
    delete: '删除',
    deleteTipTitle: '删除玻片',
    deleteTip: '是否确认删除此玻片，删除后将无法恢复！',
    successfullyDeletedTip: '删除成功',
    failedToDeleteTip: '删除失败',
    deletedTip: '提示'
  },
  // 操作按钮
  deleteButton: '删除',
  editButton: '编辑',
  diagnosisButton: '诊断',
  barcodePrintingButton: '条码打印',
  // 扫描数量统计
  scanNum: {
    tongji: '统计',
    zbls: '病例总数',
    zbps: '玻片总数',
    zupload: '总上传数',
    yesterday: '昨日',
    ydayCaseNum: '病例数',
    ydaySlideNum: '玻片数',
    ydayLayerUpNum: '已扫描/上传',
    today: '今日',
    tdayCaseNum: '病例数',
    tdaySlideNum: '玻片数',
    tdayLayerUpNum: '已扫描/上传',
    leaf: '张',
    case: '例',
    dingScanNum: '扫描中'
  },
  addNewCase: {
    patientInfo: {
      QRCodeInformation: '二维码信息：',
      QRPlaceholder: '请扫描二维码信息',
      name: '姓名：',
      namePlaceholder: '请输入姓名',
      gender: '性别：',
      genderTip: '请选择病人性别',
      menAndWomen: {
        male: '男',
        female: '女'
      },
      age: '年龄：',
      agePlaceholder: '请输入年龄',
      consultationNumber: '就诊号码：',
      consultationNumberPlaceholder: '请输入就诊号',
      typeOfCertificate: '证件类型：',
      IDNumber: '证件号码：',
      IDNumberPlaceholder: '请输入证件号码',
      medicalInsuranceCardNumber: '医保卡号：',
      medicalInsuranceCardNumberPlaceholder: '请输入医保卡号',
      dateOfBirth: '出生日期：',
      dateOfBirthPlaceholder: '请选择出生日期',
      contactNumber: '联系电话：',
      contactNumberPlaceholder: '请输入联系电话',
      jyCode: '检验单号：',
      jyCodePlaceholder: '请输入检验单号',
      address: '住址：',
      addressPlaceholder: '请输入住址',
      internetCaseSearch: '互联网病例检索：',
      checklistNumberPlaceholder: '请输入检查单号',
      correctContactNumber: '请输入正确的联系电话！',
      cancel: '取消',
      inquire: '查询'
    },
    caseInfo: {
      pathologyNumber: '病例号：',
      pathologyNumberPlaceholder: '请输入病例号',
      rapidCase: '快速病例：',
      caseType: '病例类型：',
      inspectionDepartment: '送检科室：',
      inspectionDate: '送检日期：',
      inspectionDatePlaceholder: '请选择送检日期',
      sendingDoctor: '送检医生：',
      sendingDoctorPlaceholder: '请输入送检医生',
      sendingDoctorTip: '请将关键字限制在15个字之内！',
      sentToHospital: '送检医院：',
      sampleType: '样本类型:',
      sampleTypeMessage: '请输入样本类型！',
      sampleTypeTip: '请将关键字限制在15个字之内！',
      sampleTypePlaceholder: '样本类型',
      analysisType: '分析类型:',
      analysisTypeMessage: '请输入分析类型！',
      numberOfSlides: '玻片数量:',
      operationButton: '操作',
      selectPictureButton: '选图',
      deleteButton: '删除',
      addSampleButton: '添加样本',
      hospitalNumber: '住院号：',
      hospitalNumberPlaceholder: '请输入住院号',
      ward: '病区：',
      wardPlaceholder: '请输入病区',
      bedNumber: '病床号：',
      bedNumberPlaceholder: '请输入病床号',
      phoneNumberOfSendingPhysician: '送检医师电话：',
      phoneNumberOfSendingPhysicianPlaceholder: '请输入送检医师电话',
      menstruateLastTime: '最后行经时间：',
      menstruateLastTimePlaceholder: '请选择最后行经时间',
      deadline: '截止时间：',
      deadlinePlaceholder: '请选择截止时间',
      medicalHistory: '病史：',
      medicalHistoryPlaceholder: '请输入病史',
      clinicalDiagnosis: '临床诊断：',
      clinicalDiagnosisPlaceholder: '请输入临床诊断',
      visibleToTheNakedEye: '肉眼所见：',
      visibleToTheNakedEyePlaceholder: '请输入肉眼所见',
      cancel: '取消',
      confirm: '确认',
      phoneNumberTip: '请输入正确的联系电话!',
      pathologyNumberTip: '请输入病例号!',
      CaseTypeTip: '请输入病例类型!',
      inspectionDepartmentTip: '请输入送检科室!',
      sentToHospitalTip: '请输入送检医院!',
      sendingDoctorMessage: '请输入送检医生!',
      imageManagement: '取材图像管理',
      fastTip: '请选择是否快速病例！',
      // 是否快速
      isFast: {
        yes: '是',
        no: '否'
      }
    },
    netPatientNoPaymentTip: '该检测订单未进行支付，请有疑问请联系管理员',
    netPatientNetworkErrorip: '网络错误，请重试或联系管理员',
    orderNotExistTip: '该检测订单不存在，如有疑问请联系管理员',
    addCaseTip: '请根据要求正确输入信息！',
    moreInformation: '更多信息',
    collapseInformation: '收起信息',
    consummation: '完成',
    barcodePrinting: '条码打印'
  },
  editCase: {
    patientInformation: '患者信息',
    sampleSlide: '样本玻片',
    sampleDetails: '样本详情',
    slideDetails: '玻片详情',
    sampleNumber: '样本编号：',
    sampleDescription: '样本描述：',
    saveSuccess: '病人病例信息保存成功！',
    saveFailure: '病人病例信息保存失败！',
    save: '保存',
    saveSample: '保存样本',
    captureImage: '取材图像',
    slideNumber: '玻片编号',
    saveTheSlide: '保存玻片',
    slideNumberTip: '请输入玻片编号！',
    addSampleSuccessfully: '新增样本成功！',
    failedToAddSample: '新增样本失败！',
    sampleNumberTip: '请输入样本编号！',
    // 保存样本成功
    saveTheSampleSuccessfully: '保存修改样本成功！',
    // 保存样本失败
    failedToSaveSample: '保存修改样本失败！',
    addSample: '新增样本',
    addSlide: '新增玻片',
    removeSlide: '删除玻片',
    removeSlideTip: '是否确认删除此玻片，删除后将无法恢复！',
    removeSlideSuccessfully: '删除玻片操作成功！',
    removeSlideFailed: '删除玻片操作失败！',
    saveSlideSuccessfully: '保存修改玻片成功！',
    saveSlideFailed: '保存修改玻片失败！',
    successfullyAddedSlideTip: '新增玻片成功！',
    failedToAddSlideTip: '新增玻片失败！'
  },
  captureImage: {
    successTip: '取材图像添加成功！',
    addTip: '请添加取材图像！',
    existingTip: '获取已有取材图像成功！',
    sizeOfPictureTip: '图片大小不能超过6M!',
    deletedTip: '取材图像已从数据库中删除！'
  },
  diagnosis: {
    errorReminder: '错误提醒',
    reportDoesNotExistTip: '当前病例报告不存在,请先编辑报告！',
    failedToEditReportTip: '编辑报告失败，请检查DNA.txt文件是否存在！',
    closeReport: '关闭报告',
    diagnosticResult: '诊断结果：',
    diagnosticResultPlaceholder: '请输入DNA意见...',
    comprehensiveAdvice: '综合建议：',
    comprehensiveAdvicePlaceholder: '请输入建议...',
    reportDate: '报告日期：',
    reportDatePlaceholder: '请选择报告日期...',
    reportImage: '报告图像：',
    reportImagePlaceholder: '请选择图片',
    cancel: '取消',
    saveReport: '保存报告',
    editReport: '修改报告',
    addReportResultsSuccess: '报告结果添加成功！'
  },
  message: '你好',
  caseImport: {
    title: '病例导入',
    precautionsTitle: '注意事项',
    precautionsContent1: '1. 文件格式仅支持xls,xlsx。',
    precautionsContent2: '2. 如有错误信息，请根据提示修改错误数据。',
    precautionsContent3: '3. Excel内填写的送检科室，请确保系统里已有该送检科室，否则请联系人员进行添加!!',
    precautionsContent4: '4. 将修改后的数据做成一个新的excel重新导入，直至全部成功!',
    downloadXlsx: '下载模版',
    uploadTip: '点击或拖动文件到这里上传',
    fileName: '待上传文件：',
    export: '导出',
    updateDateText: '更新时间：',
    uploading: '上传中...',
    startUpload: '开始上传',
    printing: '打印中...',
    startPrinting: '开始打印',
    analysisTypeTip: '请选择分析类型！',
    numberOfLines: '行数',
    errorMessage: '错误信息',
    fileFormatTipTitle: '文件格式不正确',
    fileFormatTipContent1: '文件',
    fileFormatTipContent2: '格式不正确，请上传.xls,.xlsx文件。',
    fileFormatUploadTip: '文件类型错误',
    fileFormatUploadTipDesc1: '文件：',
    fileFormatUploadTipDesc2: '不是EXCEL文件，请选择后缀为.xlsx或者.xls的EXCEL文件。',
    printTipConfirmTitle: '警告',
    printTipConfirmContent: '将进行打印当前已导入的病例二维码！',
    printTipConfirmOkText: '了解，确认打印',
    printTipConfirmCancelText: '不了，谢谢',
    printTipSucessTitle: '成功提示',
    printTipSucessDesc: '二维码打印成功！',
    printTipWarningTitle: '提示',
    printTipWarningDesc: '请勿重复提交！',
    uploadFunSucessTitle: '成功提示',
    uploadFunSucessDesc: '病例导入成功，如有错误信息，可导出数据列表！',
    uploadFunWarningTitle: '提示',
    uploadFunWarningDesc: '请勿重复提交！',
    handleSuccessTip: '数据导入成功！',
    uploadErrorTip: '数据导入失败！',
    exportDataTip: '暂无相关数据，请稍后再试！',
    cancelPrinting: '取消打印',
    uploadFunErrorTitle: '提示',
    uploadFunErrorDesc: '服务器端出现异常！'
  },
  scanAddNewCase: {
    title: '扫码新建',
    code: '扫码信息：',
    pathologyId: '病例编号：',
    slideCount: '制片数量：',
    sourceName: '送检来源：',
    codePlaceholder: '请扫描二维码信息...',
    pathologyIdPlaceholder: '请输入病例编号...',
    slideCountPlaceholder: '请输入制片数量...',
    sourceNamePlaceholder: '请输入送检来源...'
  }
}

export default lang



// WEBPACK FOOTER //
// ./src/utils/lang/zh-cn.js